import { QueryBuilder } from '../intellijetnet'

// Helper to ensure proper type casting for API responses
export function ensureArray<T>(data: unknown): T[] {
  if (!Array.isArray(data)) return []
  return data as T[]
}

// Helper to ensure proper type casting for single item responses
export function ensureItem<T>(data: unknown): T | null {
  if (!data || typeof data !== 'object') return null
  return data as T
}

// Helper to execute query and return typed data
export async function executeQuery<T>(builder: QueryBuilder): Promise<T[]> {
  const result = await builder.execute<T>()
  return ensureArray<T>(result.data)
}

// Helper to execute query and return first item
export async function executeQueryFirst<T>(builder: QueryBuilder): Promise<T | null> {
  const result = await builder.limit(1).execute<T>()
  const items = ensureArray<T>(result.data)
  return items[0] || null
}